<template>
    <div class="home-page">
		<Header></Header>
		<div class="mission" v-if="!notFound">
      <div class="mission-content">
        <div class="ac">
          <img style="width:50%" src="../../static/images/landing-x.png" />
        </div>
        <div class="mission-t mission-t2" style="font-size: 59px;">
          {{$t('missions2')}}
        </div>
        <div class="mission-h">
          <div class="fs27" v-html="$t('missions1')"></div>
        </div>
        <div class="mission-list">
          <div class="mission-ul ">
            <div class="mission-ul-scrool">
              <div class="mission-li title-bg disflex" v-for="(item,index) in list">
                <img src="../../static/images/select.png" v-if="item.finish">
                <img src="../../static/images/no-select.png" v-else>
                <div class="name" :class="{'none':item.finish}">{{item.title}}</div>
                <div class="fen" :class="{'none':item.finish}">+{{item.score}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:false,
			list:[],
			page_id:1,
			page_size:10,
			isShow:'All',
      listMenu:['All','action','adventure','puzzle','sports'],

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.push({path:'/index'})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.get('/api/mission/index',null,r =>{
				that.$parent.returnCode(r,function(){
					that.list = r.data

        });

			})
		},
    getList(item){
      this.isShow = item
    },
		getMore(){
			let that = this;
			if(that.isShow){
				that.page_id++;
				that.getHome();
			}else{
				//that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/mission.vue